<div class="main-toolbar-wrap">

    <div class="main-toolbar">

        <div class="main-toolbar-content">

            @if (isUserAuthorized()) {
                <nav class="main-toolbar-nav toolbar-tour-step-1-js">

                    @for (item of items(); track item.text) {
                        @if (item.type === 'divider') {
                            <div class="pnyc-divider pnyc-divider--vertical main-toolbar-divider">
                            </div>
                        } @else if (item.children) {
                            <pnyc-button class="main-toolbar-nav-btn" [text]="item.text!" pnycTooltip
                                [tooltipContentTemplate]="menuPanel" [tooltipCustomClass]="'main-toolbar-nav-dropdown'"
                                [tooltipTrigger]="'hover'">
                            </pnyc-button>

                            <ng-template #menuPanel>

                                <div class="main-toolbar-nav-menu">

                                    @for (section of item.children; track $index) {
                                        <div class="main-toolbar-nav-section">

                                            <div class="main-toolbar-nav-section-title">
                                                {{ section.text | translate }}
                                            </div>

                                            <div class="main-toolbar-nav-section-list">

                                                @for (subItem of section.children; track $index) {
                                                    <!-- TODO: DEV Close after click -->
                                                    <div class="main-toolbar-nav-section-item"
                                                        [pnycWip]="subItem.handler ? '' : 'Button not wired up'"
                                                        (click)="subItem.handler?.()">

                                                        @if (subItem.iconName) {
                                                            <pnyc-icon class="main-toolbar-nav-section-item-icon"
                                                                [iconName]="subItem.iconName">
                                                            </pnyc-icon>
                                                        }

                                                        <div class="main-toolbar-nav-section-item-info">

                                                            @if (subItem.text) {
                                                                <div class="main-toolbar-nav-section-item-info-title">
                                                                    {{ subItem.text | translate }}
                                                                </div>
                                                            }

                                                            @if (subItem.description) {
                                                                <div
                                                                    class="main-toolbar-nav-section-item-info-description">
                                                                    {{ subItem.description | translate }}
                                                                </div>
                                                            }

                                                        </div>

                                                    </div>
                                                }

                                            </div>

                                        </div>
                                    }

                                </div>

                            </ng-template>
                        } @else {
                            <pnyc-button class="main-toolbar-nav-btn" [text]="item.text!" (clicked)="item.handler?.()">
                            </pnyc-button>
                        }
                    }

                </nav>

                <logo class="main-toolbar-logo">
                </logo>

                <div class="main-toolbar-actions">

                    <customer-dropdown>
                    </customer-dropdown>

                    <div class="pnyc-divider pnyc-divider--vertical main-toolbar-divider">
                    </div>

                    <div class="main-toolbar-actions-btn-wrap toolbar-tour-step-2-js"
                        [pnycDropdown]="notificationsPanel" [xPosition]="'before'"
                        [dropdownCustomClass]="'notification-bell-dropdown'" #notificationsDropdown="pnycDropdownApi">
                        <pnyc-button class="main-toolbar-actions-btn" [title]="'TOOLBAR.TITLES.NOTIFICATIONS'"
                            [iconName]="'bell'"
                            [badge]="{ badgeCountAlert: notificationBadge(), badgeCountAlertLimit: 9 }">
                        </pnyc-button>
                    </div>

                    <ng-template #notificationsPanel>
                        <notification-bell [hasCloseButton]="false" (closeEvent)="notificationsDropdown.close()">
                        </notification-bell>
                    </ng-template>

                    @let account = userAccount();
                    @let fullName = account?.fullName;
                    @let profileImage = ''; <!-- TODO: Load from user account -->

                    @if (fullName != null) {
                        <div data-testid="profile-avatar" class="main-toolbar-user toolbar-tour-step-3-js"
                            [title]="fullName" [pnycDropdown]="userMenu" #userMenuDropdown="pnycDropdownApi"
                            [dropdownCustomClass]="'main-toolbar-user-dropdown'">

                            <pnyc-avatar class="main-toolbar-user-avatar" [userFullName]="fullName"
                                [profileImageUrl]="profileImage">
                            </pnyc-avatar>

                        </div>

                        <ng-template #userMenu>

                            <div class="main-toolbar-user-dropdown-box">

                                <div class="main-toolbar-user-dropdown-body">

                                    @for (item of userItems(); track item.text) {
                                        <pnyc-list-item [attr.data-testid]="item.testId" [text]="item.text"
                                            [iconName]="item.iconName" [type]="item.type || 'item'"
                                            [pnycWip]="item.handler || item.type !== 'item' ? '' : 'Button not wired up'"
                                            (clicked)="item.handler?.(); item.type === 'item' || userMenuDropdown.close()">
                                        </pnyc-list-item>
                                    }

                                </div>

                                <div class="main-toolbar-user-dropdown-footer">

                                    <pnyc-button
                                        class="main-toolbar-user-dropdown-footer-btn main-toolbar-user-dropdown-footer-btn--sign-out"
                                        [text]="'TOOLBAR.TITLES.LOG_OUT'" [iconName]="'log-out'"
                                        (clicked)="onLogoutClicked(); userMenuDropdown.close()">
                                    </pnyc-button>

                                </div>

                            </div>

                        </ng-template>
                    }

                </div>
            }
        </div>

    </div>
</div>